import { DATA_TYPE_LABEL, FIELD_ROLE_LABEL } from "../../../features/builder.constants";
import { ADD_OPS, DATE_TYPES, DIFF_OPS, ROLE_TYPES, SINGLE_ROLES } from "./source-field.constants";

// Pure helpers of the Source Field tab (no API, no React).

/** "add_days(deadline, -7)", "latest(project_status_histories.status)": a short, readable compute definition. */
export function computeSummary(compute) {
  if (!compute) return "—";
  if (ADD_OPS.includes(compute.op)) {
    const amount = compute.amount_path ? `+ ${compute.amount_path}` : `${Number(compute.amount ?? 0) >= 0 ? "+" : ""}${compute.amount ?? "?"}`;
    return `${compute.op}(${compute.base ?? "?"}, ${amount})`;
  }
  if (DIFF_OPS.includes(compute.op)) return `${compute.op}(${compute.from ?? "?"} -> ${compute.to || "today"})`;
  if (compute.op === "count_relation") return `count(${compute.relation ?? "?"}${compute.where ? ", where ..." : ""})`;
  if (compute.op === "latest_value") return `latest(${compute.relation ?? "?"}.${compute.field ?? "?"}${compute.default !== undefined && compute.default !== null ? `, else ${compute.default}` : ""})`;
  return "computed";
}

/** Distinct values (to fill a field's values) exist for root text / number columns only. */
export const canFillValues = (field) => Boolean(field.path && !field.path.includes(".") && ["TEXT", "INT"].includes(field.data_type));

/** A column's data type can only switch between Date and Date & time; other types follow what is read. */
export const dataTypeChoices = (field) =>
  !field.compute && DATE_TYPES.includes(field.data_type) ? DATE_TYPES.map((value) => ({ value, label: DATA_TYPE_LABEL[value] })) : null;

/** Roles a field may take: those its data type allows, none of the single roles for a computed field, no SUBJECT on a platform source. */
export const roleOptions = (field, dataType, subjectType) =>
  Object.entries(FIELD_ROLE_LABEL)
    .filter(([role]) => !ROLE_TYPES[role] || ROLE_TYPES[role].includes(dataType))
    .filter(([role]) => !(field.compute && SINGLE_ROLES.includes(role)))
    .filter(([role]) => !(role === "SUBJECT" && subjectType === "NONE"))
    .map(([value, label]) => ({ value, label }));

/** Two field values compared for the unsaved-changes check (lists by content). */
export const sameValue = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

/** field_key of the fields holding each single role ({ SUBJECT: ["user_fid"], ... }). */
export const roleHolders = (fields) =>
  Object.fromEntries(SINGLE_ROLES.map((role) => [role, (fields ?? []).filter((field) => field.field_role === role).map((field) => field.field_key)]));
